/**
 * @license
 * @copyright Copyright Motili Inc., 2018 All Rights Reserved
 */

import Config from 'Config';
import * as ApiService from './ApiService';

const BASE_URL = 'CloudinaryImages';

export function upload(file) {
    if (file.preview === Config.notApplicablePhoto.url) {
        return Promise.resolve({
            secure_url: Config.notApplicablePhoto.url,
        });
    }
    return ApiService.upload(true, `${BASE_URL}/upload`, file).then(
        response => {
            if (response.result.error) {
                return Promise.reject(
                    new Error(
                        response.result.error.message || 'Error uploading file.'
                    )
                );
            }
            return response.result;
        }
    );
}

export function uploadMultiple(files) {
    return Promise.all(files.map(upload));
}

export function cleanUpFile(file) {
    if (file?.preview) {
        URL.revokeObjectURL(file.preview);
    }
}
